import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const notificationApi = axios.create({
  baseURL: `${API_BASE_URL}/notifications`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
notificationApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const notificationService = {
  getAll: () => notificationApi.get(''),
  getUnread: () => notificationApi.get('/unread'),
  getUnreadCount: () => notificationApi.get('/unread-count'),
  markAsRead: (notificationId) => notificationApi.put(`/${notificationId}/read`),
  markAllAsRead: () => notificationApi.put('/read-all'),
};

export default notificationService;

